"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spaui = require("@tencent/spaui");

var _SearchComponent = _interopRequireDefault(require("./components/SearchComponent"));

var _EmptyComponent = _interopRequireDefault(require("./components/EmptyComponent"));

var _MenuComponent = _interopRequireDefault(require("./components/MenuComponent"));

var _lodash = _interopRequireDefault(require("lodash"));

var _DnD = _interopRequireDefault(require("./DnD"));

var _storage = require("./utils/storage");

var _index = require("./utils/index");

var _DefaultFooter = _interopRequireDefault(require("./components/DefaultFooter"));

var _StorageFooter = _interopRequireDefault(require("./components/StorageFooter"));

var _helper = require("./helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tabs = _spaui.Tabs.Tabs,
    TabPanel = _spaui.Tabs.TabPanel;
var OverlayTrigger = _spaui.PopOver.OverlayTrigger,
    PopOver = _spaui.PopOver.PopOver;
var defaultLabelsConfig = {
  selectorTitle: '已选指标'
};
var categoryTipsAdded = false;

var SpauiColumns = /*#__PURE__*/function (_PureComponent) {
  _inherits(SpauiColumns, _PureComponent);

  /**
   * 属性说明
   * @alias ColumnsProps
   * @property {bool} show=false 是否展示
   * @property {func} onSubmit 提交回调
   * @property {func} onCancel 取消关闭回调
   * @property {object} cellsConfig 字段配置
   * @property {object} cellsConfigMap 字段信息映射配置
   * @property {bool} [search=false] 是否开启搜索功能
   * @property {bool} [showDirectory=false] 是否显示左侧目录
   * @property {array} [unmovableCells=[]] 不能移动的列，跟fixed放在一起 但动不了
   * @property {array} [fixed=[]] 冻结列名称 但动不了
   * @property {number} [maxFixedNumber=5] 最大固定列的数量*包括不能移动的列*
   * @property {array} selected=[]] 非冻结列的名称
   * @property {array} [required=[]] 必选项(右侧显示已选择指标，不会有删除按钮)
   * @property {string|number} [owner=''] 广告主id（用于缓存区分key）
   * @property {string} [emptyTip='你尚未设置自定义指标'] 空字段提示
   * @property {bool} [showGuideTips=true] 是否显示导航提示
   * @property {string} [guideTipsCacheKey='spaui_showguide_'] 导航提示key
   * @property {string} [customerTipsCacheKey='spaui_customercolumn_'] 自定义指标提示key
   * @property {func|element} [TipComponent] 内容提示组件结构
   * @property {func} [getCharacterStringLength] 支持保存名称时自定义计算字符串长度方法（默认为string.length）
   * @property {boolean} [storable=false] 是否可保存（开启后会有保存的UI）
   * @property {string} [storableLabel='保存为常用自定义列'] 保存文案
   * @property {string} [storableTip=''] 保存提示
   * @property {boolean} [storageArrivalLimit=false] 存储是否到达限制（到达限制后会变成删除提示）
   * @property {number} [storageNameMaxWordNumber=10] 存储名称最多几个字符
   * @property {object} [defaultStorageData={}] 默认的存储信息，可用于设置默认名称或默认勾选保存到服务端({ checked, storageName, disabled })
   * @property {func} [onDelateStorage] 显示存储到达上限时，点击删除时的回调
   * @property {func} [FooterComponent] 尾部组件结构
   * @property {func|element} [TabRightContent] Tab右侧内容组件结构
   * @property {object} [TabRightContentStyle] Tab右侧内容组件style
   * @property {boolean} [checkAll=false] 是否显示多选
   * @property {string} [searchPlaceholder='搜索指标'] 搜索框的空数据文案
   * @property {string} [emptyDataLabel='没有找到你要的指标'] 空数据的文案
   * @property {bool} [hideFixedTipComponent=false] 是否要隐藏固定列提示
   * @property {object} [labelsConfig={}] 文案配置
   * @property {string} [emptyFixedTip=''] 空固定列文案
   * @example
   * onSubmit = ({fixed, selected})
   * labelsConfig = { selectorTitle: '已选指标' }
   */
  function SpauiColumns(props) {
    var _this;

    _classCallCheck(this, SpauiColumns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SpauiColumns).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getCellsConfig", function () {
      var searchStr = (0, _helper.getSearchStrOfState)(_this.state);
      return (0, _helper.getCellsConfigOfSearch)(_this.props.cellsConfig, _this.state.activeTab, searchStr);
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchField", function (newSearchState) {
      _this.setState(newSearchState);
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuClick", function (anchor) {
      var dom = document.getElementById(anchor);

      if (dom) {
        dom.scrollIntoView();
      }
    });

    _this.onCheckboxChange = _this.onCheckboxChange.bind(_assertThisInitialized(_this));
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    _this.onChangeOrder = _this.onChangeOrder.bind(_assertThisInitialized(_this));
    _this.onDeleteSelect = _this.onDeleteSelect.bind(_assertThisInitialized(_this));
    _this.onChangeTab = _this.onChangeTab.bind(_assertThisInitialized(_this));
    _this.closeGuide = _this.closeGuide.bind(_assertThisInitialized(_this));
    _this.footerComponent = _this.footerComponent.bind(_assertThisInitialized(_this));
    _this.guidePopOver = _this.guidePopOver.bind(_assertThisInitialized(_this));
    _this.getGuideTotal = _this.getGuideTotal.bind(_assertThisInitialized(_this));
    _this.getLabelsConfig = _this.getLabelsConfig.bind(_assertThisInitialized(_this));
    _this.onToggleCheckAll = _this.onToggleCheckAll.bind(_assertThisInitialized(_this));
    var typesOfFields = Object.keys(props.cellsConfig || {});
    var showGuideTips = _this.isNeedToShowTips(props.guideTipsCacheKey) && props.showGuideTips ? 1 : false; //展出了下次打开就不出现了

    _this.setNotShowTips(props.guideTipsCacheKey); //把这些保存在state里主要是这里有个中间态，如果点取消的话 不能影响原来的选择


    _this.state = {
      fixed: _this.props.fixed,
      required: [],
      selected: _this.props.selected,
      activeTab: typesOfFields[0] ? typesOfFields[0] : '',
      //自定义指标的提示,优先出新手指引，出完了再出自定义
      showTips: !showGuideTips && _this.isNeedToShowTips(props.customerTipsCacheKey),
      //展示新手指引的提示，false就是不展示 1,2,3,4分别代表 第一二三四步
      showGuideTips: showGuideTips,
      //收起的类，每个类下边有不止一个指标，分类只有中文名，中文名还有重复，但是指标没有重复，
      // 因此以分类下的第一个指标的fieldName来作为该类的唯一key
      folded: {//fieldName1: true //example
      }
    }; // 如果没有传递 cellsConfigMap，则根据 cellsConfig 生成一个

    if (typeof _this.props.cellsConfigMap === 'undefined') {
      _this.cellsConfigMap = (0, _helper.genCellsConfigMap)(_this.props.cellsConfig);
    }

    return _this;
  }

  _createClass(SpauiColumns, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProp) {
      var newState = {};

      if (!_lodash["default"].isEqual(nextProp.cellsConfig, this.props.cellsConfig)) {
        newState.required = _lodash["default"].cloneDeep(nextProp.required);
      }

      if (!this.state.activeTab) {
        var typesOfFields = Object.keys(nextProp.cellsConfig);
        newState.activeTab = typesOfFields[0];
      }

      if (!_lodash["default"].isEqual(nextProp.selected, this.state.selected)) {
        newState.selected = _lodash["default"].cloneDeep(nextProp.selected);
      }

      if (!_lodash["default"].isEqual(nextProp.fixed, this.state.fixed)) {
        newState.fixed = _lodash["default"].cloneDeep(nextProp.fixed);
      }

      if (!_lodash["default"].isEmpty(newState)) {
        this.setState(newState);
      }

      if (typeof nextProp.cellsConfigMap === 'undefined' && this.props.cellsConfigMap !== nextProp.cellsConfigMap) {
        this.cellsConfigMap = (0, _helper.genCellsConfigMap)(nextProp.cellsConfig);
      }
    }
  }, {
    key: "isNeedToShowTips",
    value: function isNeedToShowTips(cachekey) {
      var _this$props$owner = this.props.owner,
          owner = _this$props$owner === void 0 ? '' : _this$props$owner;

      var value = _storage.localStorage.getItem(cachekey + owner);

      return value !== '1';
    }
  }, {
    key: "setNotShowTips",
    value: function setNotShowTips(cachekey) {
      var _this$props$owner2 = this.props.owner,
          owner = _this$props$owner2 === void 0 ? '' : _this$props$owner2;

      _storage.localStorage.setItem(cachekey + owner, 1);
    }
  }, {
    key: "gotoNextGuid",
    value: function gotoNextGuid(nextStep) {
      this.setState({
        showGuideTips: nextStep
      });
    }
  }, {
    key: "getLabelsConfig",
    value: function getLabelsConfig() {
      var labelsConfig = this.props.labelsConfig;
      return _objectSpread({}, defaultLabelsConfig, labelsConfig);
    }
  }, {
    key: "onCheckboxChange",
    //指标勾选切换
    value: function onCheckboxChange(event, value) {
      var name = event.target.name;
      var checked = value ? true : false;

      var oldSelected = _lodash["default"].cloneDeep(this.state.selected);

      if (!this.canRemove(name)) {
        return;
      }

      var newState = {};

      if (checked) {
        oldSelected.push(name);
      } else {
        var index = oldSelected.indexOf(name);

        if (index > -1) {
          oldSelected.splice(index, 1);
        } else {
          var oldfixed = _lodash["default"].cloneDeep(this.state.fixed);

          var fixedIndex = oldfixed.indexOf(name);

          if (fixedIndex > -1) {
            oldfixed.splice(fixedIndex, 1);
            newState.fixed = oldfixed;
          }
        }
      }

      newState.selected = oldSelected;
      this.setState(newState);
    } //点确定

  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      var otherData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var unmovableCells = this.props.unmovableCells;

      var fixed = _lodash["default"].cloneDeep(this.state.fixed),
          selected = _lodash["default"].cloneDeep(this.state.selected);

      this.props.onSubmit(_objectSpread({}, otherData, {
        fixed: fixed,
        selected: selected,
        unmovableCells: unmovableCells
      }));
    } //右侧x掉一个指标

  }, {
    key: "removeSelectedCells",
    value: function removeSelectedCells(name) {
      var _this$state = this.state,
          selected = _this$state.selected,
          fixed = _this$state.fixed;
      var index = selected.indexOf(name);

      if (index !== -1) {
        var oldSelected = _lodash["default"].cloneDeep(selected);

        oldSelected.splice(index, 1);
        this.setState({
          selected: oldSelected
        });
      } else {
        var fixedindex = fixed.indexOf(name);

        var oldFixed = _lodash["default"].cloneDeep(fixed);

        oldFixed.splice(fixedindex, 1);
        this.setState({
          fixed: oldFixed
        });
      }
    }
  }, {
    key: "findConfigByName",
    value: function findConfigByName(name) {
      var configMap = this.cellsConfigMap || this.props.cellsConfigMap || {};
      return configMap[name];
    }
  }, {
    key: "onChangeTab",
    value: function onChangeTab(event, name) {
      this.setState({
        activeTab: name
      });
    }
  }, {
    key: "genCustomTile",
    value: function genCustomTile() {
      var _this2 = this;

      var _this$props$customerT = this.props.customerTipsCacheKey,
          customerTipsCacheKey = _this$props$customerT === void 0 ? '' : _this$props$customerT;

      var pop = _react["default"].createElement(PopOver, {
        className: "popover-dark"
      }, _react["default"].createElement("h3", {
        className: "spaui-popover-title"
      }, "\u70B9\u6B64\u9009\u62E9\u5DF2\u521B\u5EFA\u7684\u81EA\u5B9A\u4E49", _react["default"].createElement("br", null), "\u8F6C\u5316\u89C4\u5219\u3002"), _react["default"].createElement("div", {
        className: "spaui-popover-body"
      }), _react["default"].createElement("button", {
        type: "button",
        className: "spaui-button spaui-button-primary",
        onClick: function onClick(event) {
          event.stopPropagation();

          _this2.setState({
            showTips: false
          });

          _this2.setNotShowTips(customerTipsCacheKey);
        }
      }, "\u6211\u77E5\u9053\u4E86"));

      var title = _react["default"].createElement("div", null, _react["default"].createElement(OverlayTrigger, {
        trigger: "hover",
        placement: "bottom",
        overlay: pop,
        show: this.state.showTips
      }, _react["default"].createElement("div", null, "\u81EA\u5B9A\u4E49\u6307\u6807")));

      return title;
    }
  }, {
    key: "genContent",
    value: function genContent() {
      var _this3 = this;

      var _this$props = this.props,
          emptyTip = _this$props.emptyTip,
          search = _this$props.search,
          showDirectory = _this$props.showDirectory,
          TabRightContent = _this$props.TabRightContent,
          _this$props$TabRightC = _this$props.TabRightContentStyle,
          TabRightContentStyle = _this$props$TabRightC === void 0 ? {} : _this$props$TabRightC,
          searchPlaceholder = _this$props.searchPlaceholder,
          emptyDataLabel = _this$props.emptyDataLabel;
      var tabContent = [],
          emptyTipDom = null;
      var realConfig = this.getCellsConfig();
      var searchStr = (0, _helper.getSearchStrOfState)(this.state); // 当前是否是输入了搜索值

      var isSearch = (searchStr || '').length > 0;

      if (emptyTip) {
        if (typeof emptyTip === 'string') {
          emptyTipDom = _react["default"].createElement("p", {
            dangerouslySetInnerHTML: {
              __html: emptyTip
            }
          });
        } else {
          emptyTipDom = _react["default"].createElement("p", null, emptyTip);
        }
      }

      (0, _index.eachObject)(realConfig, function (tabName, tabConfig) {
        // const height = window.document.documentElement.clientHeight * 0.8 - 56 - (search ? 37 : 0) + 'px';
        var tabConfigListComponent = (_lodash["default"].get(tabConfig, 'list') || []).map(function (categoryConfig, index) {
          return _this3.genOneCategory(categoryConfig, false, index);
        });
        var mainComponent = showDirectory ? _react["default"].createElement("main", {
          className: "spaui-columns-main has-menu",
          key: "spaui-columns-main"
        }, _react["default"].createElement(_MenuComponent["default"], {
          data: (0, _helper.getMenuDataOfTab)(_this3.getCellsConfig(), tabName),
          onMenuClick: _this3.onMenuClick
        }), _react["default"].createElement("div", {
          className: "spaui-columns-config-list",
          id: "spaui-columns-config-list"
        }, tabConfigListComponent)) : _react["default"].createElement("main", {
          className: "spaui-columns-main",
          key: "spaui-columns-main",
          id: "spaui-columns-config-list"
        }, tabConfigListComponent);
        tabContent.push(_react["default"].createElement(TabPanel, {
          tab: tabConfig.name,
          name: tabName,
          key: tabName
        }, _react["default"].createElement("div", {
          className: "spaui-tabs-content" // style={{
          //    height,
          // }}

        }, search ? _react["default"].createElement(_SearchComponent["default"], {
          placeholder: searchPlaceholder,
          state: _this3.state,
          tabKey: tabName,
          onChange: _this3.onSearchField
        }) : null, tabConfig.list.length === 0 ? _react["default"].createElement(_EmptyComponent["default"], {
          isSearch: isSearch,
          emptyTipDom: emptyTipDom,
          emptyDataLabel: emptyDataLabel
        }) : mainComponent, _this3.genSelectedColumn())));
      });
      return _react["default"].createElement(Tabs, _extends({
        onChange: this.onChangeTab,
        value: this.state.activeTab,
        className: "spaui-columns spaui-columns-tabs",
        style: {
          height: window.document.documentElement.clientHeight * 0.8 + 'px'
        },
        endOfHeadContent: TabRightContent ? _react["default"].createElement("div", {
          className: "tabs-right",
          style: TabRightContentStyle
        }, TabRightContent) : undefined
      }, this.props.TabProps), tabContent);
    }
  }, {
    key: "onToggleCheckAll",
    value: function onToggleCheckAll(isSelectAll, path) {
      var _this4 = this;

      var fieldsConfigOfCate = _lodash["default"].get(this.getCellsConfig(), path, []);

      var fieldsOfCate = fieldsConfigOfCate.filter(function (fieldConfig) {
        return !_this4.props.required.includes(fieldConfig.name) && !_this4.props.unmovableCells.includes(fieldConfig.name);
      }).map(function (it) {
        return it.name;
      });
      var _this$state2 = this.state,
          _this$state2$fixed = _this$state2.fixed,
          fixed = _this$state2$fixed === void 0 ? [] : _this$state2$fixed,
          _this$state2$selected = _this$state2.selected,
          selected = _this$state2$selected === void 0 ? [] : _this$state2$selected;

      if (!isSelectAll) {
        var newState = {
          fixed: _lodash["default"].clone(fixed),
          selected: _lodash["default"].clone(selected)
        };

        _lodash["default"].pullAll(newState.fixed, fieldsOfCate);

        _lodash["default"].pullAll(newState.selected, fieldsOfCate);

        this.setState(newState);
      } else {
        var _newState = {
          selected: _lodash["default"].clone(selected)
        };
        fieldsOfCate = fieldsOfCate.filter(function (field) {
          return !_this4.state.fixed.includes(field) && !_this4.state.selected.includes(field);
        });

        if (fieldsOfCate) {
          _newState.selected = _newState.selected.concat(fieldsOfCate);
          this.setState(_newState);
        }
      }
    }
    /**
     * 按指标分类生成checkbox
     * @param configs
     * @returns {XML}
     */

  }, {
    key: "genOneCategory",
    value: function genOneCategory(configs) {
      var _this5 = this;

      var isSubCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var index = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = this.props,
          unmovableCells = _this$props2.unmovableCells,
          checkAll = _this$props2.checkAll;
      var _this$state3 = this.state,
          fixed = _this$state3.fixed,
          selected = _this$state3.selected;
      var titleCls = isSubCell ? 'spaui-columns-subsec-title' : 'spaui-columns-sec-title';
      var checkboxCls = isSubCell ? ' spaui-checkboxes-mini' : '';
      var secCls = isSubCell ? 'spaui-columns-subsec' : 'spaui-columns-sec';
      var bodyCls = isSubCell ? 'spaui-columns-subsec-body' : 'spaui-columns-sec-body';
      var cateKey = configs.columns ? configs.columns[0].name : '';
      var folded = this.state.folded;

      var title = _react["default"].createElement("span", null, configs.name);

      if (!categoryTipsAdded && index === 2) {
        categoryTipsAdded = true;
        title = _react["default"].createElement(OverlayTrigger, {
          placement: "top",
          trigger: "hover",
          show: this.state.showGuideTips === 1,
          overlay: this.guidePopOver('指标归类（1/' + this.getGuideTotal() + '）', '全面校准了平台已有指标的统计逻辑、名称和分类，新增了更多转化指标，同时删除了部分错误指标。', 1)
        }, title);
      }

      var fieldsOfThisCate = _lodash["default"].get(configs, 'columns', []).map(function (it) {
        return it.name;
      });

      var isNotAllChecked = fieldsOfThisCate.some(function (field) {
        return !unmovableCells.includes(field) && !fixed.includes(field) && !selected.includes(field);
      });
      return _react["default"].createElement("div", {
        className: secCls + (folded[cateKey] ? ' folded' : ''),
        key: index
      }, _react["default"].createElement("h3", {
        className: titleCls,
        id: configs.path
      }, configs.columns && checkAll ? _react["default"].createElement(_spaui.Checkbox, {
        id: configs.path,
        className: "mini check-all",
        value: configs.path,
        onChange: function onChange(_event, value) {
          _this5.onToggleCheckAll(!!value, configs.path);
        },
        checked: !isNotAllChecked
      }, _react["default"].createElement("span", null, configs.name)) : title), configs.columns ? _react["default"].createElement("a", {
        className: "spaui-columns-actions spaui-cursor-pointer",
        onClick: function onClick() {
          _this5.toggleCategory(cateKey);
        }
      }, _react["default"].createElement("span", {
        className: "spaui-columns-expand"
      }, _react["default"].createElement("i", {
        className: "spaui-icon-crosshair"
      }), "\u5C55\u5F00"), _react["default"].createElement("span", {
        className: "spaui-columns-folder"
      }, _react["default"].createElement("i", {
        className: "spaui-icon-minus"
      }), "\u6536\u8D77")) : null, _react["default"].createElement("div", {
        className: bodyCls
      }, configs.list ? configs.list.map(function (subConfigs, itemIndex) {
        return _this5.genOneCategory(subConfigs, true, itemIndex);
      }) : _react["default"].createElement("div", {
        className: 'spaui-checkboxes' + checkboxCls
      }, configs.columns.map(function (config) {
        var text = config.displayName || config.cellName;
        var tip = config.tip;

        var isLocked = config.required || _this5.props.required.includes(config.name);

        return _react["default"].createElement("div", {
          key: text,
          id: config.path
        }, _react["default"].createElement(_spaui.Checkbox, {
          className: 'mini ' + (isLocked ? ' islocked' : ''),
          name: config.name,
          value: 1,
          onChange: _this5.onCheckboxChange,
          checked: _this5.isChecked(config.name) || isLocked,
          disabled: isLocked
        }, tip ? _react["default"].createElement(OverlayTrigger, {
          trigger: "hover",
          placement: "top",
          showDelayTime: 400,
          hideWhenScrolling: true,
          scrollbarTarget: function scrollbarTarget() {
            return document.getElementById('spaui-columns-config-list');
          },
          overlay: _react["default"].createElement(PopOver, null, tip)
        }, text) : text));
      }))));
    }
  }, {
    key: "genFieldPopOver",
    value: function genFieldPopOver(fieldConfig) {
      return _react["default"].createElement(PopOver, {
        className: "popover-columns popover-cool popover-mini",
        style: {
          width: '250px'
        }
      }, _react["default"].createElement("p", {
        className: "spaui-popover-body"
      }, fieldConfig.tip || fieldConfig.cellName || fieldConfig.displayName));
    }
    /**
     * 展开收起某一类的指标
     * @param name
     */

  }, {
    key: "toggleCategory",
    value: function toggleCategory(name) {
      var folded = this.state.folded;

      var newFolded = _lodash["default"].extend({}, folded);

      newFolded[name] = !newFolded[name];
      this.setState({
        folded: newFolded
      });
    }
    /**
     * 真正的指标展示位置排序,放到after之后去
     */

  }, {
    key: "onChangeOrder",
    value: function onChangeOrder(id, afterId) {
      var _this$state4 = this.state,
          selected = _this$state4.selected,
          fixed = _this$state4.fixed;

      var copySelected = _lodash["default"].cloneDeep(selected);

      var copyFixed = _lodash["default"].cloneDeep(fixed);

      var itemIndex = copySelected.indexOf(id);
      var itemInSelect = true;

      if (itemIndex === -1) {
        itemIndex = copyFixed.indexOf(id);
        itemInSelect = false;
      }

      var afterIndex = copySelected.indexOf(afterId);
      var afterInSelect = true;

      if (afterIndex === -1) {
        afterIndex = copyFixed.indexOf(afterId);
        afterInSelect = false;
      } //  先把原来位置的数据删掉


      if (itemInSelect) {
        copySelected.splice(itemIndex, 1);
      } else {
        copyFixed.splice(itemIndex, 1);
      }

      if (afterId === 'split') {
        //直接放在横线下首位
        copySelected.unshift(id);
      } else if (afterIndex === -1) {
        //直接放在自定义冻结首位
        copyFixed.unshift(id);
      } else {
        //往哪里插入新的指标，固定还是非固定
        var targetArr = copyFixed;

        if (afterInSelect) {
          targetArr = copySelected;
        } //如果是上下两部分互相移动，那就直接插在对应的位置的后边


        if (itemInSelect !== afterInSelect) {
          targetArr.splice(afterIndex + 1, 0, id);
        } else {
          //内部移动要判断一下，往上移动的话，afterIndex要 +1 因为要放在后边
          if (itemIndex < afterIndex) {
            targetArr.splice(afterIndex, 0, id);
          } else {
            targetArr.splice(afterIndex + 1, 0, id);
          }
        }
      }

      var newState = {
        fixed: copyFixed,
        selected: copySelected
      };
      this.setState(newState);
    }
  }, {
    key: "onDeleteSelect",
    value: function onDeleteSelect(name) {
      this.removeSelectedCells(name);
    }
  }, {
    key: "genSelectedColumn",
    value: function genSelectedColumn() {
      var _this6 = this;

      var _this$props3 = this.props,
          unmovableCells = _this$props3.unmovableCells,
          maxFixedNumber = _this$props3.maxFixedNumber,
          hideFixedTipComponent = _this$props3.hideFixedTipComponent,
          _this$props3$emptyFix = _this$props3.emptyFixedTip,
          emptyFixedTip = _this$props3$emptyFix === void 0 ? '' : _this$props3$emptyFix;

      var _this$getLabelsConfig = this.getLabelsConfig(),
          selectorTitle = _this$getLabelsConfig.selectorTitle;

      var dndData = [];
      unmovableCells.forEach(function (name) {
        var cfg = _this6.findConfigByName(name);

        if (cfg) {
          dndData.push({
            text: cfg.displayName,
            id: name,
            unmovable: true
          });
        }
      });
      var _this$state5 = this.state,
          fixed = _this$state5.fixed,
          selected = _this$state5.selected;
      var haveFixed = false;
      fixed.forEach(function (name) {
        var cfg = _this6.findConfigByName(name);

        if (cfg) {
          dndData.push({
            text: cfg.displayName,
            id: name,
            deletable: _this6.canRemove(name)
          });
          haveFixed = true;
        }
      }); // 如果没有固定列，得放一个假的才能够拖动上来

      if (!haveFixed && emptyFixedTip) {
        dndData.push({
          text: emptyFixedTip,
          id: 'default_fixed_column',
          deletable: false,
          unmovable: true
        });
      }

      dndData.push('split');
      selected.forEach(function (name) {
        var cfg = _this6.findConfigByName(name);

        if (cfg) {
          dndData.push({
            text: cfg.displayName,
            id: name,
            deletable: _this6.canRemove(name)
          });
        }
      });
      var dndProps = {
        data: dndData,
        onMove: this.onChangeOrder,
        showGuideTips: this.state.showGuideTips,
        guidePopOver: this.guidePopOver,
        getGuideTotal: this.getGuideTotal,
        onDelete: this.onDeleteSelect,
        maxFixedNumber: maxFixedNumber,
        hideFixedTipComponent: hideFixedTipComponent,
        emptyFixedTip: emptyFixedTip
      };
      return _react["default"].createElement("aside", {
        className: "spaui-columns-aside",
        key: "columns-aside"
      }, _react["default"].createElement("div", {
        className: "spaui-columns-aside-title"
      }, selectorTitle), _react["default"].createElement("div", {
        className: "spaui-columns-aside-bd"
      }, _react["default"].createElement("div", {
        className: "spaui-columns-selected"
      }, _react["default"].createElement(_DnD["default"], dndProps))));
    }
  }, {
    key: "isChecked",
    value: function isChecked(name) {
      return this.state.fixed.indexOf(name) > -1 || this.state.selected.indexOf(name) > -1;
    }
  }, {
    key: "canRemove",
    value: function canRemove(name) {
      return this.props.required.indexOf(name) === -1;
    }
  }, {
    key: "footerComponent",
    value: function footerComponent(props) {
      var onCancel = props.onCancel,
          submitLabel = props.submitLabel,
          cancelLabel = props.cancelLabel;
      var _this$props4 = this.props,
          TipComponent = _this$props4.TipComponent,
          _this$props4$tipUrl = _this$props4.tipUrl,
          tipUrl = _this$props4$tipUrl === void 0 ? '' : _this$props4$tipUrl,
          _this$props4$storable = _this$props4.storable,
          storable = _this$props4$storable === void 0 ? false : _this$props4$storable,
          defaultStorageData = _this$props4.defaultStorageData;
      var tipComponentInstance = null,
          Footer = null;

      if (typeof TipComponent !== 'undefined') {
        if (typeof TipComponent === 'function') {
          tipComponentInstance = _react["default"].createElement(TipComponent, _extends({}, this.state, this.props, {
            currentState: this.state
          }));
        } else {
          tipComponentInstance = TipComponent;
        }
      } else if (tipUrl) {
        tipComponentInstance = _react["default"].createElement(OverlayTrigger, {
          placement: "top",
          trigger: "hover",
          show: this.state.showGuideTips === 4,
          overlay: this.guidePopOver('新旧指标对应关系（4/4）', '更多指标解释和本次自定义指标迭代调整详情，请由此前往了解。', 4)
        }, _react["default"].createElement("a", {
          href: tipUrl,
          target: "_blank"
        }, _react["default"].createElement("i", {
          className: "spaui-icon spaui-columns-icon-lib"
        }), "\u65B0\u65E7\u6307\u6807\u5BF9\u5E94\u5173\u7CFB"));
      }

      if (_lodash["default"].isFunction(this.props.FooterComponent)) {
        Footer = this.props.FooterComponent;
      } else if (storable) {
        Footer = _StorageFooter["default"];
      } else {
        Footer = _DefaultFooter["default"];
      }

      return _react["default"].createElement(Footer, {
        tip: tipComponentInstance,
        onCancel: onCancel,
        cancelLabel: cancelLabel,
        onSubmit: this.onSubmit,
        submitLabel: submitLabel,
        getCharacterStringLength: this.props.getCharacterStringLength,
        storageArrivalLimit: this.props.storageArrivalLimit,
        onDelateStorage: this.props.onDelateStorage,
        storageNameMaxWordNumber: this.props.storageNameMaxWordNumber,
        defaultStorageData: defaultStorageData,
        storableTip: this.props.storableTip,
        storableLabel: this.props.storableLabel
      });
    }
  }, {
    key: "closeGuide",
    value: function closeGuide() {
      var _this7 = this;

      var _this$props5 = this.props,
          _this$props5$customer = _this$props5.customerTipsCacheKey,
          customerTipsCacheKey = _this$props5$customer === void 0 ? '' : _this$props5$customer,
          _this$props5$guideTip = _this$props5.guideTipsCacheKey,
          guideTipsCacheKey = _this$props5$guideTip === void 0 ? '' : _this$props5$guideTip;
      this.setState({
        showGuideTips: false
      });
      this.setNotShowTips(guideTipsCacheKey);

      if (this.isNeedToShowTips(customerTipsCacheKey)) {
        setTimeout(function () {
          _this7.setState({
            showTips: true
          });
        }, 2000);
      }
    }
  }, {
    key: "getGuideTotal",
    value: function getGuideTotal() {
      var _this$props$tipUrl = this.props.tipUrl,
          tipUrl = _this$props$tipUrl === void 0 ? '' : _this$props$tipUrl;
      var result = 3;

      if (tipUrl) {
        result += 1;
      }

      return result;
    }
  }, {
    key: "guidePopOver",
    value: function guidePopOver(title, desc, step) {
      var _this8 = this;

      var total = this.getGuideTotal();
      return _react["default"].createElement(PopOver, {
        className: 'popover-columns popover-dark popover-mini'
      }, _react["default"].createElement("h3", {
        className: "spaui-popover-title"
      }, title), _react["default"].createElement("div", {
        className: "spaui-popover-body"
      }, desc), _react["default"].createElement(_spaui.Button, {
        bsSize: "small",
        bsStyle: "primary",
        onClick: function onClick() {
          if (step < total) {
            _this8.setState({
              showGuideTips: step + 1
            });
          } else {
            _this8.closeGuide();
          }
        }
      }, step < total ? '下一个' : '完成'), _react["default"].createElement("a", {
        className: "spaui-popover-close spaui-cursor-pointer",
        onClick: this.closeGuide
      }, _react["default"].createElement("i", {
        className: "icon-crosshair icon-del"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$className = this.props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className;

      if (this.props.show === false) {
        return null;
      }

      return _react["default"].createElement(_spaui.Dialog, _extends({
        submitLabel: this.props.submitLabel,
        cancelLabel: this.props.cancelLabel,
        backdrop: true,
        className: 'modal-columns modal-columns-new ' + className,
        scrollBarHidden: false,
        title: "\u81EA\u5B9A\u4E49\u5217"
      }, this.props.dialogProps || {}, {
        show: this.props.show,
        FooterComponent: this.footerComponent,
        onSubmit: this.onSubmit,
        onClose: this.props.onCancel,
        onCancel: this.props.onCancel
      }), this.genContent());
    }
  }]);

  return SpauiColumns;
}(_react.PureComponent);

_defineProperty(SpauiColumns, "defaultProps", {
  show: false,
  onSubmit: '',
  onCancel: '',
  cellsConfig: {},
  unmovableCells: [],
  fixed: [],
  required: [],
  selected: [],
  owner: '',
  emptyTip: '你尚未设置自定义指标',
  showGuideTips: true,
  guideTipsCacheKey: 'spaui_showguide_',
  customerTipsCacheKey: 'spaui_customercolumn_',
  tipUrl: '',
  storable: false,
  storableTip: '',
  storableLabel: '保存为常用自定义列',
  storageArrivalLimit: false,
  storageNameMaxWordNumber: 10,
  onDelateStorage: _lodash["default"].noop,
  getCharacterStringLength: _index.getCharacterStringLength,
  defaultStorageData: {},
  maxFixedNumber: 5,
  search: false,
  showDirectory: false,
  checkAll: false,
  searchPlaceholder: '搜索指标',
  emptyDataLabel: '没有找到你要的指标',
  hideFixedTipComponent: false,
  labelsConfig: defaultLabelsConfig,
  emptyFixedTip: ''
});

var _default = SpauiColumns;
exports["default"] = _default;